export default "__VITE_ASSET__BqixbOcw__"